<div class="itsl-course-info-box__content">
    <div class="itsl-course-info-box__title">{title}</div>
    <div class="itsl-course-info-box__description">{description?.length ? description : ""}</div>
    {#if showTeachers}
        <CourseInfoBoxTeachers courseTeachersTitle={i18n.courseTeachers} {teachers} />
    {/if}
    {#if canAdminGeneral}
        <Link kind="secondary-standalone" href={editPageUrl}>{i18n.edit}</Link>
    {/if}
</div>

<script>
    import Link from "@itslearning/prometheus/assets/Navigation/Link/v1/Link.svelte";
    import CourseInfoBoxTeachers from "./CourseInfoBoxTeachers.svelte";

    export let canAdminGeneral;
    export let description;
    export let editPageUrl;
    export let i18n;
    export let showTeachers;
    export let teachers;
    export let title;
</script>
